__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-ee885ecc/_next/";